import { render, staticRenderFns } from "./ManagePriceListImport.vue?vue&type=template&id=671c99ac&scoped=true"
import script from "./ManagePriceListImport.vue?vue&type=script&lang=js"
export * from "./ManagePriceListImport.vue?vue&type=script&lang=js"
import style0 from "./ManagePriceListImport.vue?vue&type=style&index=0&id=671c99ac&prod&scoped=true&lang=css"
import style1 from "./ManagePriceListImport.vue?vue&type=style&index=1&id=671c99ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671c99ac",
  null
  
)

export default component.exports